import { ActivationStatus, ProductActivation } from '@vendasta/sales-orders';
import { PackageItemActivationStatus } from './package-dropdown/sales-package';

export function convertActivationsToPackageItemActivationStatuses(
  productActivations: ProductActivation[],
): PackageItemActivationStatus[] {
  return productActivations
    ? productActivations
        .filter((productActivation) => productActivation.activationStatus !== ActivationStatus.PENDING)
        .map((productActivation) => {
          return {
            packageItemId: productActivation.productId,
            status: productActivation.activationStatus,
            uniqueId: productActivation.uniqueId,
            editionId: productActivation.editionId,
            previousEditionId: productActivation.previousEditionId,
            isEditionChange: productActivation.isEditionChange,
          };
        })
    : [];
}
